import React, { useEffect } from "react";
import "../css/contactus.scss";
import { Link } from "react-router-dom";
import { STORE } from "../config/store";

function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="contact">
      <div className="container container--small">
        <div className="main-page__breadcrumbs">
          <nav className="breadcrumbs breadcrumbs--center" aria-label="Breadcrumb">
            <ul className="breadcrumbs__list list-unstyled"><li><Link to="/">Home</Link></li><li className="breadcrumbs__separator">/</li><li><span>Contact {STORE.brand}</span></li></ul>
          </nav>
        </div>
        <h1 className="main-page__title h1">Contact Us</h1>
        <div className="main-page__content font-size-md rte">
          <p>Email is the customer-service channel for orders, delivery, returns, product safety, privacy, accessibility and intellectual-property concerns.</p>
          <div className="contact-card">
            <h2>Email</h2>
            <p><a href={`mailto:${STORE.supportEmail}`}>{STORE.supportEmail}</a></p>
            <p>Operating region: {STORE.operatingRegion}<br />Store currency: {STORE.currency}<br />Business time zone: {STORE.timeZone}</p>
          </div>
          <h2>Help us find the right record</h2>
          <p>Help us locate an order by quoting its reference, checkout email and item name, followed by a short account of the issue. When goods are damaged or incorrect, preserve all packing and add clear images showing the goods, parcel and shipping label.</p>
          <h2>Protect your payment details</h2>
          <p>Leave the entire card number, its expiry and its security code out of every email. Enter those credentials exclusively on the provider's payment screen.</p>
        </div>
      </div>
    </main>
  );
}

export default Contact;
